import { useState, useContext, useEffect } from 'react';
import { NuevaONGContext } from '../context/NuevaONGContext';
import { AuthContext } from '../context/authContext';
import { Input, Label, Select_simple } from './ui';
import ListaContactosProyecto from './ListaContactosProyecto';
import { Modal } from './ui/Modal';
import { optionsPartido, optionsCategoria, optionsLPO } from '../datos/options';
import { textoContactoAfectado } from '../utils/contactos';
import { toast, ToastContainer } from "react-toastify"

const FormularioNuevaONG = ({ ongData, onSave, onCancel }) => {
  const { setNuevaONG } = useContext(NuevaONGContext);
  const { token } = useContext(AuthContext);
  
  // Estados del formulario
  const [codigo, setCodigo] = useState('');
  const [partidoSede, setPartidoSede] = useState({ value: '', label: '' });
  console.log(partidoSede);
  const [ONG, setONG] = useState('');
  const [resolucion, setResolucion] = useState('');
  const [categoria, setCategoria] = useState('');
  const [agrupacionTerminalPolitica, setAgrupacionTerminalPolitica] = useState('');
  const [referentePolitico, setReferentePolitico] = useState('');
  const [contactos, setContactos] = useState([]);
  const [lpo, setLpo] = useState('');

  // Los contactos tal como vinieron de la base. Se comparan contra esta copia
  // para saber que cambio DE VERDAD y no preguntar por el resto: sin esto el
  // aviso de impacto abriria por contactos que el usuario ni toco.
  const [baseline, setBaseline] = useState([]);

  // El aviso previo de que las obras van a seguir mostrando el dato anterior.
  // Es el mismo modal que usa la pagina de contactos.
  const [impactoPendiente, setImpactoPendiente] = useState(null);

  //nuevo estado para seleccion multiple
  const [selectedMunicipalityIds, setSelectedMunicipalityIds] = useState([]);

  // Actualizar estados cuando cambia ongData
	useEffect(() => {
		if (ongData) {
			setCodigo(ongData.codigo || '');
			// Si partido_sede es un string, buscar el objeto correspondiente
			if (ongData.partidosede) {
				const partido = optionsPartido.find(p => p.value === ongData.partidosede) ||
					{ value: ongData.partidosede, label: ongData.partido_nombre || ongData.partidosede };
				setPartidoSede(partido);
			} else {
				setPartidoSede({ value: '', label: 'Seleccionar...' });
			}
			setONG(ongData.nombre || '');
			setResolucion(ongData.resolucion || '');
			setCategoria(ongData.categoria || '');
			setAgrupacionTerminalPolitica(ongData.ref_1_agrupacion_terminal_politica || '');
 			setReferentePolitico(ongData.ref_2_referente_politico || '');
			// Los contactos llegan en la misma respuesta de la ONG (los pide
			// obtenerONGPorId). No se arma el array con ref_3/contacto a mano:
			// esos campos se vaciaron en la migracion 061.
			setContactos(Array.isArray(ongData.contactos) ? ongData.contactos : []);
			setBaseline(Array.isArray(ongData.contactos) ? ongData.contactos : []);
			setLpo(ongData.lpo || '');
			setSelectedMunicipalityIds(ongData.municipios_seleccionados_ids || []);
		}
	}, [ongData]);

	// Manejador específico para el select simple
    const handleSedeChange = (e) => {
        const selectedValue = e.target.value;
		// Encontrar la opción seleccionada completa
		const selectedOption = optionsPartido.find(opt => opt.value === selectedValue) ||
			{ value: '', label: 'Seleccionar...' };
		setPartidoSede(selectedOption);

	};

	// Obras que tienen CARGADO un contacto que el usuario acaba de cambiar.
	//
	// El cg_12 de cada obra es una copia congelada del dato del contacto: guardar
	// el catalogo no la toca y el cambio recien se ve cuando se abre y guarda ESA
	// obra. Sin este aviso el usuario cambia un telefono, no ve nada en la obra
	// y concluye que no se guardo.
	//
	// Solo se preguntan los contactos que CAMBIARON contra el baseline: los que
	// todavia no existen en el catalogo (contacto_id 0) no tienen ninguna obra y
	// los que no cambiaron no alteran nada.
	const obrasDeContactosEditados = async (lista, base) => {
		if (!ongData?.id) return [];
		const basePorId = new Map((Array.isArray(base) ? base : [])
			.map(c => [c.contacto_id, c]));
		const texto = (v) => String(v ?? '').trim();
		const ids = (Array.isArray(lista) ? lista : [])
			.filter(c => {
				if (!c.contacto_id) return false;
				const previo = basePorId.get(c.contacto_id);
				if (!previo) return false;
				return texto(previo.nombre) !== texto(c.nombre)
					|| texto(previo.telefono) !== texto(c.telefono)
					|| texto(previo.email) !== texto(c.email);
			})
			.map(c => c.contacto_id);
		if (ids.length === 0) return [];

		const qs = new URLSearchParams({ ids: ids.join(',') });
		try {
			const r = await fetch(`/api/ongs/${ongData.id}/obras-contactos?${qs}`, {
				headers: { Authorization: `Bearer ${token}` }
			});
			if (!r.ok) {
				// Si la consulta falla se guarda igual: el aviso es una ayuda,
				// no un motivo para impedir guardar.
				console.error('No se pudieron consultar las obras de los contactos:', r.status);
				return [];
			}
			const datos = await r.json();
			return Array.isArray(datos) ? datos.filter(a => (a?.obras?.length ?? 0) > 0) : [];
		} catch (e) {
			console.error('Error al consultar las obras de los contactos:', e);
			return [];
		}
	};


	const handlePartidoSedeChange = (e) => {

		setSelectedMunicipalityIds(e.target.value);
		
		/*if (e.target.name === 'municipios_seleccionados_ids') {
			setSelectedMunicipalityIds(prev => ({
				...prev,
				[e.target.name]: e.target.value
			}));
		} else {
			// Lógica para otros inputs si los hay
			setPartidoSede(prev => ({
				...prev,
				[e.target.name]: e.target.value
			}));
		}*/
	
	};

	const handleMunicipalityChange = (e) => {
		const selectedOptions = Array.from(e.target.selectedOptions).map(
			(option) => option.value
		);
		setSelectedMunicipalityIds(selectedOptions);
	};

  // Antes de guardar se pregunta que obras tienen cargado los contactos que
  // cambiaron. Si hay alguna, se abre el modal de impacto y el guardado espera a
  // que el usuario confirme: sin esto el cambio se guarda y la obra sigue
  // mostrando el dato viejo, y no hay forma de saber que paso.
  const prepararGuardado = async (event) => {
    event.preventDefault();
    const cambios = await obrasDeContactosEditados(contactos, baseline);
    if (cambios.length > 0) {
      setImpactoPendiente({ lista: contactos, afectadas: cambios });
      return;
    }
    await ejecutarGuardado(contactos);
  };

  const confirmarGuardarImpacto = async () => {
    if (!impactoPendiente) return;
    const { lista } = impactoPendiente;
    setImpactoPendiente(null);
    await ejecutarGuardado(lista);
  };

  const cancelarGuardarImpacto = () => setImpactoPendiente(null);

  const ejecutarGuardado = async (listaContactos) => {
	const municipios_seleccionados_ids = selectedMunicipalityIds.map(m => m.id);
	const municipios_seleccionados_nombres = selectedMunicipalityIds.map(m => m.label);


    const datosONG = {
      ...(ongData?.id && { id: ongData.id }), // Incluir el id solo si existe
      codigo,
      partidosede: partidoSede.value,
      partidoSedeNombre: partidoSede.label,
      nombre: ONG,
      resolucion,
      categoria,
      ref_1_agrupacion_terminal_politica: agrupacionTerminalPolitica,
      ref_2_referente_politico: referentePolitico,
      // ref_3 y contacto se siguen mandando (vacias) para no romper el
      // contrato del endpoint; los contactos van en el array de abajo.
      ref_3_referente_organizacion: '',
      contacto: '',
      contactos: listaContactos,
      lpo,
	  municipios_seleccionados_ids,
	  municipios_seleccionados_nombres			
    };

    try {
      let response;
      let mensajeExito;

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      };
      if (ongData && ongData.id) {
        response = await fetch(`/api/ongs/${ongData.id}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(datosONG),
        });
        mensajeExito = 'ONG actualizada exitosamente!';
      } else {
        response = await fetch('/api/ongs', {
          method: 'POST',
          headers,
          body: JSON.stringify(datosONG),
        });
        mensajeExito = 'ONG creada exitosamente!';
      }

      if (response.ok) {
        console.log(mensajeExito);
		toast(mensajeExito);
        const resultado = await response.json();
        setNuevaONG(resultado);

        // El aviso de impacto ya se mostro ANTES de guardar (el modal), asi que
        // aca no se repite. Si se llego a guardar igual, el backend devuelve
        // 'afectadas' y se avisa igual, porque el usuario pudo usar "Guardar
        // igual" y el cambio sigue sin verse en la obra.
        const afectadas = Array.isArray(resultado?.sync?.afectadas)
            ? resultado.sync.afectadas.filter(a => (a?.obras?.length ?? 0) > 0)
            : [];
        if (afectadas.length > 0) {
            console.log('Obras con el dato anterior de contactos editados:',
                afectadas.map(textoContactoAfectado).join(' | '));
            toast(`${afectadas.length === 1 ? '1 contacto editado' : `${afectadas.length} contactos editados`}: `
                + `las obras que lo tienen cargado siguen con el dato anterior hasta que se guarden.`,
                { autoClose: 12000 });
        }

        // Lo que el backend NO pudo hacer. Antes esto se descartaba en silencio
        // y el usuario veia "ONG actualizada exitosamente!" sin saber que un
        // contacto quedo a medias o que hubo un conflicto con otro.
        const bloqueados = Array.isArray(resultado?.sync?.bloqueados) ? resultado.sync.bloqueados : [];
        if (bloqueados.length > 0) {
            const detalle = bloqueados.map(b => {
                const donde = b.obras > 1 ? `${b.obra} y ${b.obras - 1} más` : b.obra;
                return `${b.nombre || `contacto ${b.contacto_id}`} (obra ${donde})`;
            }).join(', ');
            toast(`No se pudo quitar ${bloqueados.length === 1 ? 'un contacto' : `${bloqueados.length} contactos`}: `
                + `${bloqueados.length === 1 ? 'lo usa' : 'los usan'} obras (${detalle}).`, { autoClose: 12000 });
        }
        const conflictos = Array.isArray(resultado?.sync?.conflictos) ? resultado.sync.conflictos : [];
        if (conflictos.length > 0) {
            const detalle = conflictos.map(c => `${c.nombre || `contacto ${c.contacto_id}`} (igual a «${c.igualA}»)`).join(', ');
            toast(`No se pudo editar ${conflictos.length === 1 ? 'un contacto' : `${conflictos.length} contactos`}: `
                + `${conflictos.length === 1 ? 'ya existe otro con esos datos' : 'ya existen otros con esos datos'} (${detalle}).`,
                { autoClose: 12000 });
        }

        if (onSave) {
          onSave(resultado);
        }

        //if (!ongData) {
          // Limpiar formulario solo en modo creación
          setCodigo('');
          setPartidoSede({ value: '', label: '' });
          setONG('');
          setResolucion('');
          setCategoria('');
          setAgrupacionTerminalPolitica('');
          setReferentePolitico('');
          setContactos([]);
          // El baseline tambien se vacia: si se guardo de nuevo sin tocar nada,
          // no hay que volver a preguntar por contactos que ya no cambiaron.
          setBaseline([]);
          setLpo('');
        //}
      } else {
        const errorData = await response.json();
        console.error('Error al guardar la ONG:', errorData);
      }
    } catch (error) {
      console.error('Error de red:', error);
    }
  };

	return (
		<>
			<form onSubmit={prepararGuardado} className="bg-white dark:bg-gray-900 shadow-md rounded px-8 pt-6 pb-8 mb-4">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{/* Columna Izquierda */}
					<div className="space-y-4">
						<div>
							<Label htmlFor="codigo">Código</Label>
							<Input
								id="codigo"
								type="text"
								placeholder="Código de la ONG"
								value={codigo}
								onChange={(e) => setCodigo(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="partidoSede">Partido sede</Label>
							<Select_simple
								id="partidoSede"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsPartido
								]}
								value={partidoSede.value} //partidoSede
								//onChange={setPartidoSede}
								onChange={handleSedeChange}
								required
							/>
						</div>

						{/*<div>
							<Label htmlFor="municipios">Municipios</Label>
							<Select_simple
								id="municipios"
								name="municipios_seleccionados_ids"
								size={4}
								multiple={true}
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsPartido
								]}
								value={selectedMunicipalityIds.map(m => m.id)} // Aquí está la clave
								onChange={handlePartidoSedeChange}
								required
							/>
						</div>*/}

						<div>
							<Label htmlFor="nombre">Nombre de la ONG</Label>
							<Input
								id="nombre"
								type="text"
								placeholder="Nombre de la ONG"
								value={ONG}
								onChange={(e) => setONG(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="resolucion">Resolución</Label>
							<Input
								id="resolucion"
								type="text"
								placeholder="Número de resolución"
								value={resolucion}
								onChange={(e) => setResolucion(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="categoria">Categoría</Label>
							<Select_simple
								id="categoria"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsCategoria.map(c => ({ value: c.value, label: c.label }))
								]}
								value={categoria}
								onChange={(e) => setCategoria(e.target.value)}
								required
							/>
						</div>
					</div>

					{/* Columna Derecha */}
					<div className="space-y-4">
						<div>
							<Label htmlFor="agrupacionTerminalPolitica">Agrupación/Terminal Política</Label>
							<Input
								id="agrupacionTerminalPolitica"
								type="text"
								value={agrupacionTerminalPolitica}
								onChange={(e) => setAgrupacionTerminalPolitica(e.target.value)}
								placeholder="Ingrese la agrupación/terminal política"
							/>
						</div>

						<div>
							<Label htmlFor="referentePolitico">Referente Político</Label>
							<Input
								id="referentePolitico"
								type="text"
								value={referentePolitico}
								onChange={(e) => setReferentePolitico(e.target.value)}
								placeholder="Ingrese el referente político"
							/>
						</div>

						{/* Los contactos de la ONG se administran acá. Reemplazan a los
						    campos ref_3_referente_organizacion y contacto, que eran un
						    solo referente con canales mezclados en texto libre y se
						    vaciaron en la migracion 061. */}
						<div className="md:col-span-2">
							<ListaContactosProyecto
								scope={ongData?.id ? { tipo: 'ong', ongId: ongData.id } : null}
								contactos={contactos}
								onChange={setContactos}
								etiquetaTitulo="Contactos de la organización"
								mensajeVacio="No hay contactos cargados para esta organización."
							/>
						</div>

						<div>
							<Label htmlFor="lpo">LPO</Label>
							<Select_simple
								id="lpo"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsLPO.map(l => ({ value: l.value, label: l.label }))
								]}
								value={lpo}
								onChange={(e) => setLpo(e.target.value)}
							/>
						</div>
					</div>
				</div>

				<div className="mt-6 flex justify-end space-x-4">
					<button
						type="button"
						onClick={() => {
							// Limpiar todos los campos
							setCodigo('');
							setPartidoSede({ value: '', label: '' });
							setONG('');
							setResolucion('');
							setCategoria('');
							setAgrupacionTerminalPolitica('');
						setReferentePolitico('');
						setContactos([]);
						setLpo('');
							// Si hay una función onCancel (para modo edición), llamarla
							if (onCancel) onCancel();
						}}
						className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
					>
						{ongData ? 'Cancelar' : 'Limpiar'}
					</button>
					<button
						type="submit"
						className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
					>
						{ongData ? 'Actualizar ONG' : 'Crear ONG'}
					</button>
				</div>
			</form>
			<ToastContainer />

			{/* Aviso de impacto: se abre ANTES del PUT para poder cancelar. El
			    cg_12 de cada obra es una copia congelada del dato del contacto,
			    asi que guardar el catalogo no cambia lo que la obra muestra: el
			    cambio se va a ver recien cuando se abra y se guarde esa obra. */}
			{impactoPendiente && (
				<Modal
					isOpen={true}
					onClose={cancelarGuardarImpacto}
					title="El cambio se va a ver recién en esas obras"
				>
					<p className="text-sm text-gray-700 dark:text-gray-200">
						Estás por cambiar {impactoPendiente.afectadas.length === 1
							? 'un contacto' : `${impactoPendiente.afectadas.length} contactos`}
						{' '}que {impactoPendiente.afectadas.length === 1 ? 'tiene' : 'tienen'} obras cargadas.
						El contacto de esas obras es una copia del dato actual: el cambio{' '}
						<strong>no se ve todavía</strong>, va a aparecer cuando abras cada obra y la
						guardes.
					</p>
					<ul className="mt-3 space-y-2">
						{impactoPendiente.afectadas.map(a => (
							<li
								key={a.contacto_id}
								className="rounded-md border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-3 py-2"
							>
								<div className="text-sm font-medium text-gray-900 dark:text-gray-100">
									{(a?.nombre || '').trim() || `contacto ${a?.contacto_id ?? '?'}`}
								</div>
								<div className="mt-1 flex flex-wrap gap-1">
									{(Array.isArray(a.obras) ? a.obras : []).map(codigo => (
										<span
											key={codigo}
											className="rounded bg-white dark:bg-gray-800 border border-amber-300 dark:border-amber-700 px-1.5 py-0.5 text-xs text-gray-700 dark:text-gray-200"
										>
											{codigo}
										</span>
									))}
								</div>
							</li>
						))}
					</ul>
					<p className="mt-3 text-xs text-gray-500 dark:text-gray-400">
						El catálogo se guarda igual. Para que una obra tome el dato nuevo hay que
						entrar a esa obra y guardarla.
					</p>
					<div className="mt-4 flex justify-end gap-2">
						<button
							type="button"
							onClick={cancelarGuardarImpacto}
							className="px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
						>
							Cancelar
						</button>
						<button
							type="button"
							onClick={confirmarGuardarImpacto}
							className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
						>
							Guardar igual
						</button>
					</div>
				</Modal>
			)}
		</>
	);
};

export default FormularioNuevaONG;